var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMyClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 31.5C7 29.6435 7.7375 27.863 9.05025 26.5503C10.363 25.2375 12.1435 24.5 14 24.5H28C29.8565 24.5 31.637 25.2375 32.9497 26.5503C34.2625 27.863 35 29.6435 35 31.5C35 32.4283 34.6312 33.3185 33.9749 33.9749C33.3185 34.6313 32.4283 35 31.5 35H10.5C9.57174 35 8.6815 34.6313 8.02513 33.9749C7.36875 33.3185 7 32.4283 7 31.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5C23.8995 17.5 26.25 15.1495 26.25 12.25C26.25 9.35051 23.8995 7 21 7C18.1005 7 15.75 9.35051 15.75 12.25C15.75 15.1495 18.1005 17.5 21 17.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMyClients);
export default __webpack_public_path__ + "static/media/DashboardMyClients.e895d14d14f5314ebd84cb98d30f44fd.svg";
export { ForwardRef as ReactComponent };